import { Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import HomePage from "./components/HomePage";
import AboutUsPage from "./components/AboutUsPage";
import NewsPage from "./components/NewsPage";
import ContactsPage from "./components/ContactsPage";
import OrdersPage from "./components/OrdersPage";
import SingleNewsPage from "./components/SingleNewsPage";
import './components/static/css/style.css'
import { RoutesProvider } from "./components/RoutesContext";
import {routes} from "./components/RoutesContext";
import NotFoundPage from "./components/NotFoundPage";

function App() {
  return (
    <RoutesProvider>
      <Header />
      
      <Routes>
        <Route element={<HomePage />} path={routes.home_page} exact />
        <Route element={<AboutUsPage />} path={routes.about_us} exact />
        <Route element={<NewsPage />} path={routes.news} exact />
        <Route element={<ContactsPage />} path={routes.contacts} exact />
        <Route element={<OrdersPage />} path={routes.orders} exact />
        <Route element={<SingleNewsPage />} path={routes.single_news} exact />
        <Route element={<NotFoundPage />} path="*" />
      </Routes>

      <Footer />

    </RoutesProvider>
  );
}

export default App;
